<template>
  <div class="pro">
    <page-banner title="产品中心" content="拥有多种智能产品"></page-banner>
    <div class="product-box">
      <div class="breadcrumb-nav">
        <v-breadcrumb separator="/" separatorClass="fa fa-angle-right">
          <v-breadcrumb-item to="/">首页</v-breadcrumb-item>
          <v-breadcrumb-item to="/product">产品中心</v-breadcrumb-item>
          <v-breadcrumb-item to="/product">{{product.type_name}}</v-breadcrumb-item>
          <v-breadcrumb-item :to="'/product/'+this.$route.params.pro_id">{{product.product_name}}</v-breadcrumb-item>
        </v-breadcrumb>
      </div>
      <h3 class="pro-title">{{product.product_name}}</h3>
      <el-carousel indicator-position="outside" height="400px">
        <el-carousel-item v-for="item in product.images" :key="item.id">
          <img :src="'/'+item.path" alt width="100%" height="100%">
        </el-carousel-item>
      </el-carousel>
      <h4>产品简介</h4>
      <pre class="intt" v-html="product.pro_int"></pre>
    </div>
  </div>
</template>
<style scoped>
.intt {
  margin: 10px;
  font-size: 16px;
}
.pro {
  width: 100%;
  height: 100%;
}
.pro-title {
  margin: 10px 0px;
  text-align: center;
}
.product-box {
  width: 1000px;
  height: 100%;
  margin: 0px auto;
  padding-bottom: 25px;
}
</style>
<script>
export default {
  name: "pro",
  data() {
    return {
      product: null
    };
  },
  methods: {},
  mounted() {
    // console.log(this.$route.params.pro_id);
    var pro_id = this.$route.params.pro_id,
      _this = this;
    $.ajax({
      url: "/product.php?id=" + pro_id,
      type: "get",
      data: null,
      success: function(data, textStatus, jqXHR) {
        _this.product = JSON.parse(data);
      }
    });
  },
  watch: {
    /** 监听路由对象，路由参数发生变化则更新组件 */
    $route: function() {
      var pro_id = this.$route.params.pro_id,
        _this = this;
      $.ajax({
        url: "/product.php?id=" + pro_id,
        type: "get",
        data: null,
        success: function(data, textStatus, jqXHR) {
          _this.product = JSON.parse(data);
        }
      });
    }
  }
};
</script>






// WEBPACK FOOTER //
// src/components/showProduct.vue